export * from "./skyscraper1.component";